<div class="container">
  <h2 class="my-5">Getting To Taniti</h2>

  <section class="row">
    <p>
      Almost all visitors arrive to Taniti by air, though some arrive on a small cruise ship that
      docks in Yellow Leaf Bay for one night per week. Taniti is served by a small airport that can
      accommodate small jets and propeller planes. Taniti is in the process of expanding the airport
      so larger jets will be able to land on the island within the next few years.
    </p>
  </section>

  <hr class="my-5">

  <section class="row" id="air">
    <div class="col-md-9">
      <h3>By Air</h3>
      <p>
        Being serviced by only a small airport, United Airlines is the only airline that flies in and out of Taniti
        to and from neighboring countries and larger islands.
      </p>
      <p>
        <a class="btn btn-outline-primary" href="https://www.united.com/en/us/" target="_blank">Find Flights</a>
      </p>
    </div>
  </section>

  <hr class="my-5">


  <section class="row" id="sea">
    <div class="col-md-9">
      <h3>By Sea</h3>
      <p>
        Carnival Cruise Lines regularly offers packages with scheduled stops in Taniti, sometimes for multiple days.
      </p>
      <p>
        <a class="btn btn-outline-primary" href="https://www.carnival.com/" target="_blank">Find Packages</a>
      </p>
    </div>
  </section>

</div>
